import { render, staticRenderFns } from "./Diente.vue?vue&type=template&id=2494db50&scoped=true&"
import script from "./Diente.vue?vue&type=script&lang=js&"
export * from "./Diente.vue?vue&type=script&lang=js&"
import style0 from "./Diente.vue?vue&type=style&index=0&id=2494db50&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2494db50",
  null
  
)

export default component.exports